import {axios} from "@/api/config";



// 查询上传信息配置列表
export function listDataConfiguration(params) {
  return axios.get(`/dataConfiguration/list`, params, true);
}

// 查询上传信息配置详细
export function getDataConfiguration(id) {
  return axios.get(`/dataConfiguration/${id}`, id, true)
}
// 新增上传信息配置
export function addDataConfiguration(params) {
  return axios.post('/dataConfiguration/addDataConfiguration', params, false);
}

// 修改上传信息配置
export function updateDataConfiguration(params) {
  return axios.post('/dataConfiguration/editDataConfiguration', params, false);
}

// 删除上传信息配置
export function delDataConfiguration(id) {
  return axios.delete(`/dataConfiguration/${id}`, true)
}
